import {Box, Tooltip} from '@primer/react'
import {SubIssuesSummaryToken} from './SubIssuesSummaryToken'
import type {SubIssueCompletionTokenProps} from './SubIssuesSummaryToken'
import {graphql, useFragment} from 'react-relay'

import type {SubIssuesSummary$key} from './__generated__/SubIssuesSummary.graphql'

interface SubIssueSummaryProps {
  issue: SubIssuesSummary$key
  onSummaryClick?: (event: React.MouseEvent, issueNode: {url: string} & unknown) => void
}

export function SubIssuesSummary({issue, onSummaryClick}: SubIssueSummaryProps) {
  const data = useFragment(
    graphql`
      fragment SubIssuesSummary on Issue {
        url
        subIssuesSummary {
          total
          completed
          percentCompleted
        }
      }
    `,
    issue,
  )

  const {total, completed, percentCompleted} = data.subIssuesSummary

  const anchorAttrs: Partial<SubIssueCompletionTokenProps> | undefined = onSummaryClick && {
    as: 'a',
    href: data.url,
    onClick: e => onSummaryClick(e, data),
  }

  return total > 0 ? (
    <Box sx={{gridArea: 'main-content', ml: 2, display: 'flex', alignItems: 'center'}}>
      <Tooltip aria-label={`${percentCompleted}% completed`}>
        <SubIssuesSummaryToken
          {...anchorAttrs}
          progress={{
            total,
            completed,
            percentCompleted,
          }}
        />
      </Tooltip>
    </Box>
  ) : null
}

try{ SubIssuesSummary.displayName ||= 'SubIssuesSummary' } catch {}